export * from "./src/taxonomy";
//# sourceMappingURL=index.js.map